"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../../../../../../../ui/Input"));
var _pluralTranslations = require("../../../../../../../../localization/pluralTranslations");
var _LabelControl = _interopRequireDefault(require("../LabelControl"));
var _styles = _interopRequireDefault(require("../../styles.scss"));
var _constants = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var BirthdayControl = function BirthdayControl(_ref) {
  var childrenAge = _ref.childrenAge,
    errorMsg = _ref.errorMsg,
    id = _ref.id,
    value = _ref.value,
    _onBlur = _ref.onBlur,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHover = _useState2[0],
    setIsHover = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  var pluralYearsTranslation = (0, _pluralTranslations.usePluralYearsTranslation)();
  var onMouseEnterHandler = (0, _react.useCallback)(function () {
    setIsHover(true);
  }, []);
  var onMouseLeaveHandler = (0, _react.useCallback)(function () {
    setIsHover(false);
  }, []);
  var onFocusHandler = (0, _react.useCallback)(function () {
    setIsFocused(true);
  }, []);
  var isShowChildPlaceholder = childrenAge && !isHover && !isFocused && !value;
  return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
    className: (0, _classnames.default)(_styles.default.birthday, _styles.default.label),
    id: id,
    label: t('BIRTHDAY_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    className: _styles.default.select,
    errorMsg: errorMsg,
    hasError: Boolean(errorMsg),
    id: id,
    mask: isShowChildPlaceholder ? null : _constants.PHONE_MASK,
    placeholder: isShowChildPlaceholder ? "".concat(childrenAge, " ").concat(pluralYearsTranslation(childrenAge)) : t('BOOKING_FORM_DATE_MASK'),
    value: value,
    onBlur: function onBlur(event) {
      _onBlur(event);
      if (childrenAge) {
        setIsFocused(false);
      }
    },
    onChange: onChange,
    onFocus: childrenAge ? onFocusHandler : undefined,
    onMouseEnter: childrenAge ? onMouseEnterHandler : undefined,
    onMouseLeave: childrenAge ? onMouseLeaveHandler : undefined
  }));
};
BirthdayControl.propTypes = {
  id: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  childrenAge: _propTypes.default.number,
  errorMsg: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func
};
BirthdayControl.defaultProps = {
  onChange: function onChange() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  }
};
var _default = exports.default = (0, _react.memo)(BirthdayControl);